// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2d8a6304","732":"843b1dec","977":"37f7e730"}[chunkId] + ".chunk.js";
};